import script from "./Cinematography.vue?vue&type=script&setup=true&lang=js"
export * from "./Cinematography.vue?vue&type=script&setup=true&lang=js"

import "./Cinematography.vue?vue&type=style&index=0&id=210aefc4&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-210aefc4"]])

export default __exports__